import { useQuery } from '@tanstack/react-query';
import { apiClient, providerKeys } from '../api';

export function useProviders() {
  return useQuery({
    queryKey: providerKeys.list(),
    queryFn: apiClient.getProviders,
    staleTime: 5 * 60 * 1000, // 5 minutes - providers don't change often
  });
}
